import React from 'react';
import { useTranslation } from 'react-i18next';
import { Chip } from '@mui/material';
import moment from 'moment';

import { i18nt } from '../../../../../../../../root';
import { NS_COMMON, NSC_PATIENT, NSPP_PATIENT } from '../../../../../../../../services/i18n/namespaces';

import './NotesInfo.scss';

const NotesInfo = ({ notesInfo }) => {
  const { t } = useTranslation();
  const prepareValue = (noteValue, referredLength = 40) => {
    if (noteValue.length > referredLength) {
      return noteValue.substring(0, referredLength) + '...';
    }
    return noteValue;
  };

  return (
    <div className="notes-chips">
      {(notesInfo?.patientFirstName || notesInfo?.patientLastName) && (
        <Chip
          size="small"
          label={`${t('info.patientName', { ns: NSPP_PATIENT })}: ${prepareValue(
            `${notesInfo.patientFirstName} ${notesInfo.patientLastName}`,
            17
          )}`}
        />
      )}
      <Chip
        size="small"
        label={`${t('info.dob', { ns: NSPP_PATIENT })}: ${
          notesInfo?.dateOfBirth ? prepareValue(getPatientBirthDateAndAge(notesInfo.dateOfBirth)) : 'N/A'
        }`}
      />
      <Chip
        size="small"
        label={`${t('subjectId', { ns: NSC_PATIENT })}: ${
          notesInfo?.subjectId ? prepareValue(notesInfo.subjectId, 7) : 'N/A'
        }`}
      />
      <Chip
        size="small"
        label={`${t('patientId', { ns: NSC_PATIENT })}: ${
          notesInfo?.patientId ? prepareValue(notesInfo.patientId) : 'N/A'
        }`}
      />
      <Chip
        size="small"
        label={`${t('study', { ns: NS_COMMON })}: ${notesInfo?.studyName ? prepareValue(notesInfo.studyName) : 'N/A'}`}
      />
      <Chip
        size="small"
        label={`${t('site', { ns: NS_COMMON })}: ${notesInfo?.siteName ? prepareValue(notesInfo.siteName) : 'N/A'}`}
      />
    </div>
  );
};

export const getPatientBirthDateAndAge = date => {
  return `${moment(date).format('DD/MMM/YYYY')} (${moment().diff(date, 'years')} ${i18nt('years')})`;
};

export default NotesInfo;
